<field-relation-readonly *ngIf="field.readonly; else editable" [field]="field"></field-relation-readonly>
<ng-template #editable>
  <field-relation-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-relation-single>
  <field-relation-multiple *ngIf="field.multiple" [formGroup]="formGroup" [field]="field"></field-relation-multiple>
</ng-template>
